import { Component, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { StoreDataService } from '@common/services/store-data.service';
import { Router } from '@angular/router';
import { SpinnerService } from '@common/services/spinner.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
declare global {
    interface Window {
        dataLayer: any[];
    }
}
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
    spinnerSubscription!: Subscription;
    isSpinnerVisible = false;
    constructor(
        private storeDataService: StoreDataService,
        private router: Router,
        public spinnerService: SpinnerService,
        private cdr: ChangeDetectorRef
    ) {
        this.storeDataService.routeToContinueBooking.subscribe((res) => {
            this.router.navigate([res], {
                queryParams: { continueBooking: null },
                queryParamsHandling: 'merge',
            });
        });
    }

    ngOnInit(): void {
        this.injectGtmScript();
        this.storeDataService.setupInitialData();
        this.spinnerSubscription = this.spinnerService.getSpinnerState().subscribe((state) => {
            this.isSpinnerVisible = state;
            this.cdr.detectChanges();
        });
    }

    private injectGtmScript() {
        const { gtmId, gtmAuth, gtmPreview } = environment;
        if (!gtmId || !gtmAuth || !gtmPreview) {
            console.warn(
                'GTM variables are missing from environment file. GTM script not injected.'
            );
            return;
        }
        window.dataLayer = window.dataLayer || [];
        const gtmScript = document.createElement('script');
        gtmScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl+
      '&gtm_auth=${gtmAuth}&gtm_preview=${gtmPreview}&gtm_cookies_win=x';
      f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
        document.head.appendChild(gtmScript);
    }

    ngOnDestroy(): void {
        this.spinnerSubscription.unsubscribe();
    }
}
